import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Layout } from "@/components/Layout";
import { GymLayout } from "@/components/GymLayout";
import { AdminLayout } from "@/components/AdminLayout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Academies from "@/pages/Academies";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import PaymentSuccess, { PaymentCancel } from "@/pages/PaymentSuccess";
import Account from "@/pages/Account";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/auth/AuthPages";

import GymDashboard from "@/pages/gym/GymDashboard";
import WholesaleCatalog from "@/pages/gym/WholesaleCatalog";
import WholesaleOrderForm from "@/pages/gym/WholesaleOrderForm";
import WholesaleOrders from "@/pages/gym/WholesaleOrders";
import GymArtwork from "@/pages/gym/GymArtwork";
import GymAccount from "@/pages/gym/GymAccount";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminAcademies from "@/pages/admin/AdminAcademies";
import AdminRounds from "@/pages/admin/AdminRounds";
import AdminProduction from "@/pages/admin/AdminProduction";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/academies" element={<Academies />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-confirmation" element={<OrderConfirmation />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/login" element={<Login />} />
              <Route path="/gym/login" element={<Login gym />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/account"
                element={<ProtectedRoute roles={["customer", "admin", "gym_owner"]}><Account /></ProtectedRoute>}
              />
            </Route>

            <Route
              path="/gym"
              element={<ProtectedRoute roles={["gym_owner"]} redirect="/gym/login"><GymLayout /></ProtectedRoute>}
            >
              <Route index element={<GymDashboard />} />
              <Route path="catalog" element={<WholesaleCatalog />} />
              <Route path="order/:productId" element={<WholesaleOrderForm />} />
              <Route path="orders" element={<WholesaleOrders />} />
              <Route path="artwork" element={<GymArtwork />} />
              <Route path="account" element={<GymAccount />} />
            </Route>

            <Route
              path="/admin"
              element={<ProtectedRoute roles={["admin", "production"]}><AdminLayout /></ProtectedRoute>}
            >
              <Route index element={<AdminDashboard />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="academies" element={<AdminAcademies />} />
              <Route path="rounds" element={<AdminRounds />} />
              <Route path="production" element={<AdminProduction />} />
              <Route path="analytics" element={<AdminAnalytics />} />
            </Route>
          </Routes>
          <Toaster position="top-center" theme="dark" />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
